// extracted by mini-css-extract-plugin
module.exports = {"colorDate":"NDatepicker_colorDate__8IO5K"};